import EsusView from 'components/esus/EsusView'
import React from 'react'
import { useLocation } from 'react-router'

export default () => {
  const { search } = useLocation()

  return <EsusView url={`/pec/user/cds/cadastroIndividual/detail${search}`} />
}
